<template>
  <div>
    <!--  <text-des v-for="(item, index) in list" :value="item" :key="item.id">
      <span slot="title">
        <span class="titlemenu">{{ item.title }}</span></span
      >
      <span slot="append">{{ item.appendTitle }}</span>
    </text-des> -->

    <text-des
      v-for="(item, index) in list"
      :value="item"
      :key="index"
      :title="titleList[index].title"
      @changeText="changeText"
    >
      <span slot="title">
        <span class="titlemenu">{{ titleList[index].title }}</span></span
      >
      <template v-if="titleList[index].title === '考试时间'">
        <template slot="append">
          <el-date-picker
            size="medium"
            v-model="anotherContent"
            @change="changeTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
          <span>{{ restTime }}</span>
        </template>
      </template>
      <span v-else slot="append">{{ titleList[index].appendTitle }}</span>
    </text-des>
    <Confirm @savePage="saveData" />
    <!-- <div v-for="(item, index) in list" :key="item.title">
      <div class="mt-4">
        <span class="titlemenu mt-4">{{ item.title }}</span
        ><span class="title-append"></span>
      </div>

      <div class="classManger">
        <rich-text
          :id="'id' + index + 2"
          :ids="index + 2"
          :value="item"
        ></rich-text>
      </div>
    </div> -->
  </div>
</template>

<script>
/* 考试报名 */
import ue2 from "@/components/common/UE2.vue";
import RichText from "../components/RichText.vue";
import TextDes from "../components/TextDes.vue";
import Confirm from "../components/Confirm.vue";
import commonMixin from "../mixin/index.js";
export default {
  components: { ue2, RichText, TextDes, Confirm },
  mixins: [commonMixin],
  props: {
    com: {
      tyoe: String,
      default: "",
    },
  },
  data() {
    return {
      anotherContent: "",
      value1: "",
      titleList: [
        { title: "考试时间", appendTitle: "" },
        {
          title: "考试方式",
          appendTitle: "机考还是笔试，需要准备哪些材料",
        },
        {
          title: "考试题型",
          appendTitle: "",
        },
      ],
      list: [],
    };
  },
  methods: {
    changeTime(t1, t2) {
      console.log(t1, t2);
      this.list[0].anotherContent = t1;
      this.savePage();
    },

    dateDiffer(Date_end) {
      //date1结束时间
      let date1 = new Date(Date_end);
      //date2当前时间
      let date2 = new Date();
      date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      const diff = date1.getTime() - date2.getTime(); //目标时间减去当前时间
      let num = diff / (24 * 60 * 60 * 1000); //计算当前时间与结束时间之间相差天数
      return `考试倒计时: ${isNaN(num) ? "" : num >= 0 ? num : ""}天`;
    },
  },
  watch: {
    anotherContent: {
      handler(val) {
        // this.anotherContent = val
      },
    },
    value: {
      handler(val) {
        const list = val.subjectGuideItemDetails || [];

        this.list = list;
        if (this.list[0]["title"] === "考试时间") {
          if (this.list[0].anotherContent) {
            this.anotherContent = this.list[0].anotherContent;
          }

          console.log("this.anotherContent", this.anotherContent);
        }
      },
      deep: true,
      immediate: true,
    },
    /*  list: {
      handler(list) {
        if (window.sessionStorage.getItem("anotherContent")) {
          this.anotherContent = JSON.parse(
            window.sessionStorage.getItem("anotherContent")
          );
          window.sessionStorage.removeItem("anotherContent")
        }
      },
      deep: true,
      immediate: true,
    }, */
  },
  created() {},
  computed: {
    restTime() {
      return this.dateDiffer(this.anotherContent);
    },
  },
};
</script>
<style scoped>
.myfade-enter-active,
.myfade-leave-active {
  transition: all 0.2s ease-out;
}

/* 进场的瞬间与离场的效果添加 */
.myfade-enter,
.myfade-leave-to {
  opacity: 0;
  transform: translateX(200px);
}

.titlemenu {
  font-weight: 600;
  font-size: 16px;
}

.title-append {
  margin-left: 1rem;
  color: #a5a5a5;
}

.mt-4 {
  margin-top: 1rem;
}

.i-icon {
  font-size: 16px;
  display: inline-block;
  color: #66b1ff;
  cursor: pointer;
}

.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}

.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}

.table_bottom {
  margin: 20px 0;
}

.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}

.campusManage-search {
  padding: 0px 10px;
}

.campusManage-tree {
  margin-top: 10px;
}

.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/module/detailsTheTest.vue